import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'lg',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 transform hover:scale-105 text-center';
  const variants = {
    primary: 'bg-gold hover:bg-gold-light text-mystic-900 shadow-gold hover:shadow-gold-lg',
    secondary: 'bg-mystic-700 border border-gold/30 text-gold hover:bg-mystic-800 hover:border-gold'
  };
  const sizes = {
    md: 'px-6 py-3 text-sm md:text-base',
    lg: 'px-8 py-4 text-base md:text-lg w-full md:w-auto'
  };
  return <a className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-235">
      {children}
    </a>;
}